/**
 * MedCaddy API Client - Auth Module
 * Handles authentication: register, login, logout, CSRF fetch.
 */

import {
  API_URL,
  apiFetch,
  clearAuthState,
  getHasSession,
  setHasSession,
  ensureCsrf,
  setCsrfToken,
  fetchCsrfToken
} from './core';

// Auth API
export const auth = {
  async register(email, password, firstName, lastName) {
    const headers = { 'Content-Type': 'application/json' };
    await ensureCsrf(headers);

    const response = await fetch(`${API_URL}/auth/register`, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify({ email, password, firstName, lastName })
    });
    return response.json();
  },

  async login(email, password, mfaCode = null) {
    const body = { email, password };
    if (mfaCode) body.mfaCode = mfaCode;

    const headers = { 'Content-Type': 'application/json' };
    await ensureCsrf(headers);

    const response = await fetch(`${API_URL}/auth/login`, {
      method: 'POST',
      headers,
      credentials: 'include',
      body: JSON.stringify(body)
    });

    const data = await response.json();

    if (response.ok && data.csrfToken) {
      setCsrfToken(data.csrfToken);
      setHasSession(true);
    }

    return { ok: response.ok, data };
  },

  /** Purpose: Executes logout. Inputs: none. Output: Promise with operation result. */
  async logout() {
    try {
      if (getHasSession()) {
        await apiFetch('/auth/logout', { method: 'POST' });
      }
    } finally {
      clearAuthState();
    }
  },

  /** Purpose: Executes fetch csrf. Inputs: none. Output: Promise with operation result. */
  async fetchCsrf() {
    return fetchCsrfToken();
  }
};
